module.exports = __webpack_public_path__ + "static/uni_uncf-01652524a4127b3f44ac92ce13af8c4b.png";